import React from 'react'
import { ApolloClient, ApolloLink } from '@apollo/client'
import { InMemoryCache } from '@apollo/client/cache'
import { onError } from '@apollo/client/link/error'
import { createUploadLink } from 'apollo-upload-client'

import { buildAxiosFetch } from '@lifeomic/axios-fetch'
import axios from 'axios'

const isObject = (node) => typeof node === 'object' && node !== null

// rough first draft, could probably be optimised in a loads of different ways.
const hasFiles = (node, found = []) => {
	Object.keys(node).forEach((key) => {
		if (!isObject(node[key]) || found.length > 0) {
			return
		}

		if (
			(typeof File !== 'undefined' && node[key] instanceof File) ||
			(typeof Blob !== 'undefined' && node[key] instanceof Blob)
		) {
			found.push(node[key])
			return
		}

		hasFiles(node[key], found)
	})

	return found.length > 0
}

function createApolloClient() {
	return new ApolloClient({
		link: ApolloLink.from([
			onError(({ graphQLErrors, networkError }) => {
				if (graphQLErrors) {
					graphQLErrors.forEach(({ message, locations, path }) =>
						console.error(
							`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
							locations,
						),
					)
				}
				if (networkError) {
					console.error(`[Network error]: ${networkError}`)
				}
			}),
			// IMPORTANT: use a relative URI so axios.baseURL controls which API host we hit.
			createUploadLink({
				uri: '/graphql',
				fetch: buildAxiosFetch(axios),
			}),
		]),
		cache: new InMemoryCache(),
		shouldBatch: false,
		defaultOptions: {
			query: {
				fetchPolicy: 'cache-and-network',
			},
		},
	})
}

export default createApolloClient

export {
	createApolloClient,
}
